import { useMutation, useQuery } from '@tanstack/react-query';

import {
  getBranches,
  getStatisticServicesDictionary,
  getStatisticStrategiesDictionary,
  getUnsubscribeClientsStatistic,
} from '../../../../api';
import { PageParams } from '../../../../types/pagination';

export const useUnsubscribeClientsStatistic = () =>
  useMutation({
    mutationKey: ['getUnsubscribeClientsStatistic'],
    mutationFn: (data: PageParams) => getUnsubscribeClientsStatistic(data),
  });

export const useBranchesDictionary = () => useQuery({ queryKey: ['getBranches'], queryFn: () => getBranches() });

export const useStrategiesDictionary = () =>
  useQuery({ queryKey: ['getStatisticStrategiesDictionary'], queryFn: () => getStatisticStrategiesDictionary() });

export const useServicesDictionary = () =>
  useQuery({ queryKey: ['getStatisticServicesDictionary'], queryFn: () => getStatisticServicesDictionary() });
